const getters = {
  langs: state => state.app.lang
}
export default getters
